<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>등록일</strong></b-col>
          <b-col sm="3">
            <date-picker v-model="fullDateTmp"
                         type="date"
                         style="width: 100%;"
                         range
                         placeholder="조회기간 선택"
                         :lang="datepickerLang"
                         @change="handleDateRangeChange"/>
          </b-col>
          <b-col sm="6">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>


        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>상품구분</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="payorder-group" v-model="queryParams.view_type" :options="salesProductOptions" name="payorder-options"/>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>판매구분</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="payorder-group" v-model="queryParams.view_type" :options="salesProductOptions" name="payorder-options"/>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>결제구분</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="payorder-group" v-model="queryParams.view_type" :options="salesProductOptions" name="payorder-options"/>
          </b-col>
        </b-row>


      </b-card>
    </b-col>
  </b-row>
</template>
<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'
import { EventBus } from "../../../event-bus";

export default {
  name: 'SalesSearch',
  props: {
    queryParams: {
      type: Object
    },
    fullDate: {
      type: Array,
    },
  },
  components: {
    DatePicker
  },
  data () {
    return {
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },

      salesProductOptions: [
        {text: '전체',value: 'all'},
        {text: '계정상품',value: 'AUP'},
        {text: '개별보고서',value: 'DRP'},
        {text: '종합보고서(제책본)',value: 'ADB'},
        {text: '종합보고서(파일본)',value: 'ADF'},
      ], // 상품구분 타입

      salesOptions: [
        {text: '전체',value: 'all'},
        {text: '소비자자',vaue: 'AUP'},
        {text: '영업지원',value: 'DRP'},
        {text: '내부제공',value: 'ADB'},
        {text: 'NCP',value: 'ADF'},
        {text: '기타',value: 'ADF'},
      ], // 상품구분 타입

      view_type_options: [
        {text: '조회', value: 'VIEW'},
        {text: '추천', value: 'RECOMMAND'},
        {text: '다운로드', value: 'DOWNLOAD'},
        {text: '후속연구요청', value: 'RESEARCH'},
      ],
      fullDateTmp: [],
    }
  },

  mounted() {
  },
  methods: {

    getContentStatisticsInfoUserList() {
      this.queryParams.keyword = this.queryParams.keyword.replace(/\s/g, '');
      EventBus.$emit('callFindDrUserList');
    },

    handleDateRangeChange() {
      this.$parent.fullDate = this.fullDateTmp;
      console.log('handleDateRangeChange >>>>', this.$parent.fullDate);
    },

    // 날짜 정의
    dateRange(flag) {
      let endDate;
      let startDate;
      if(this.fullDateTmp.length === 0){
        endDate = new Date();
        startDate = new Date();
      }else{
        endDate = this.fullDateTmp[1];
        startDate = _.clone(this.fullDateTmp[1]);
      }

      if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
        this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/sales/component/SalesSearch.vue